import React from 'react'
import Link from 'gatsby-link'
import { Button } from 'antd'


const PageNotFound = (props) => (
  <div className="markdown--content">

    <h1>Error! 404 Page Not Found.</h1>
    <p>The page you're looking for <code>{ props.location.pathname }</code> doesn't exist or It could be just hidden for the time being or unpublished or you don't have right permission(s) to access it.</p>

    <p>If you think this is a mistake?</p>
    <ul>
      <li><Link to="/contact">Let me know</Link></li>
      <li><a href="https://twitter.com/dhruv_kumar_jha" target="_blank">Tweet about this to me</a></li>
    </ul>

    <Link to="/articles" className="no--style">
      <Button type="primary" ghost>Feel free to checkout some of the Tutorials written by me.</Button>
    </Link>

  </div>
)

export default PageNotFound


/*


  <div className="page--404 markdown--content">

    <h1 style={{ marginBottom: 0 }}>Error!</h1>
    <h1>404 Page Not Found.</h1>
    <p>The page you're looking for doesn't exist or you don't have permission to access it.</p>
    <p>If you think this is a mistake? Just <Link to="/contact">Let me know</Link> or Tweet it to me.</p>

  </div>

const PageNotFound = () => (
  <div className="">

    <h1 style={{ marginBottom: 0 }}>Error!</h1>
    <h1>404 Page Not Found.</h1>
    <p>The page you're looking for doesn't exist or you don't have permission to access it.</p>

  </div>
)

const PageNotFound = () => (
  <div className="component--centered page--404 mb bordered">

    <h1>Page Not Found</h1>
    <p>You just hit a route that doesn't exist... the sadness.</p>

  </div>
)
*/



// WEBPACK FOOTER //
// ./src/pages/404.js